import { useEffect, useState } from "react";
import Modal from "../../Modal";
import RemoteConsentSlider from "../../RemoteConsentSlider";
import "./ConfirmConsentStyles.css";
import useCollect from "../../../hooks/useCollect";
import { FormattedMessage, useIntl } from "react-intl";
import { setLoader } from "../../../features/LoaderSlice";
import { useDispatch } from "react-redux";
import useConsentFragment from "../../../hooks/useConsentFragment";

const ConfirmRemoteConsentModal = ({
  isSentConsentOpen,
  setIsSentConsentOpen,
  user,
  handleSubmitCollect,
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const { getVersionInfo } = useConsentFragment();
  const [loading, setLoading] = useState(false);
  const [versionInfo, setVersionInfo] = useState();
  const { controllerCode, customerScope, type, value, language, contactEmail } =
    user;

  useEffect(() => {
    const loadVersionInfo = async () => {
      if (
        !isSentConsentOpen ||
        handleSubmitCollect ||
        !controllerCode ||
        !customerScope ||
        !language
      ) {
        return;
      }

      const data = await getVersionInfo(
        controllerCode,
        customerScope,
        language,
      );
      setVersionInfo(data);
    };

    loadVersionInfo();
  }, [
    isSentConsentOpen,
    handleSubmitCollect,
    controllerCode,
    customerScope,
    language,
  ]);

  const handleSumitConsent = () => {
    if (handleSubmitCollect) handleSubmitCollect();
    else {
      dispatch(setLoader({ loading: true, label: "" }));
      identityCollect(
        {
          controller_code: controllerCode,
          customer_scope: customerScope,
          type,
          value,
          language,
          collection_channel: "Truman UI",
          last_update_channel: "Truman UI",
          contact_email: contactEmail,
        },
        false,
        true,
        {},
        true,
        false,
        true,
        versionInfo,
      )
        .then((res) => {
          handleCollectSuccessMessage(res);
          dispatch(setLoader({ loading: false, label: "" }));
          setIsSentConsentOpen(false, true);
          setLoading(false);
        })
        .catch((error) => {
          handleCollectErrorMessage(error);
          dispatch(setLoader({ loading: false, label: "" }));
          setIsSentConsentOpen(false, true);
          setLoading(false);
        });
    }
  };
  return (
    <Modal
      title={intl.formatMessage({
        id: "confirm-remote-consent.title",
        defaultMessage: "Confirm Remote consent invitation",
      })}
      open={isSentConsentOpen}
      setOpen={setIsSentConsentOpen}
      onSubmit={handleSumitConsent}
      isDisabled={loading}
    >
      <p className="consent-title">
        <FormattedMessage
          id="confirm-remote-consent.description"
          defaultMessage="When you click on confirm, the email recipient will receive a link to provide remote consent. Please view the preview screens below."
        />
      </p>
      <RemoteConsentSlider />
    </Modal>
  );
};

export default ConfirmRemoteConsentModal;
